<template>
    <div>
        <!--<div>这里应该根据不同的{{rootColumnId}}</div>-->
        <el-row>
            <el-col :span="5">
                <div class="grid-content bg-purple">
                    <!--显示对应顶部一级导航栏下的二级左边导航栏-->
                    <div class="left-nav-container">
                        <!--二级导航栏，如果点击的是左边的，则显示相应的样式-->
                        <div class="left-nav-list"
                             :class="level1ColumnId===item.columnId?'left-nav-list-active':''"
                             v-for="(item,index) in level1ColumnList"
                             :key="index"
                             @click="getArticleByLevel1ColumnId(item.columnId)">
                                <span>{{item.columnName}}</span>
                        </div>
                    </div>
                </div>
            </el-col>

            <!--中间文章列表-->
            <el-col :span="12" style="margin-top: -10px">
                <div class="grid-content bg-purple-light article_list">
                    <!--文章列表-->
                    <ArticleList :level1ColumnId="level1ColumnId"></ArticleList>
                </div>
            </el-col>

            <el-col :span="5">
                <el-aside width="300px" style="margin-left: 50px">
                    <el-card style="height: 200px">
                        <h4>希望是附丽于存在的，有存在，便有希望，有希望便是光明</h4>
                    </el-card>
                </el-aside>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import {getLevel1Column} from "@/api/get";
    import ArticleList from '../components/ArticleList.vue'
    export default {
        name: "RootColumn",
        components:{ArticleList},
        data(){
          return{
              rootColumnId: '',
              level1ColumnId: '',
              level1ColumnList:[],
          }
        },
        watch: {
            /*监听路由变化*/
            $route:{
                handler(){
                    this.rootColumnId = this.$route.params && this.$route.params.rootColumnId;
                    // this.level1ColumnList = "";
                    this.getLevel1Column()
                },
                immediate: true
            }
        },
        created() {
            this.rootColumnId = this.$route.params && this.$route.params.rootColumnId;
            // this.getLevel1Column()
        },
        methods: {
            getLevel1Column(){
                var rootColumnId = this.rootColumnId;
                getLevel1Column(rootColumnId).then(response => {
                    // console.log("getLevel1Column这里"+JSON.stringify(response.data))
                    this.level1ColumnList = response.data
                    /*初始化第一个level1ColumnId*/
                    this.level1ColumnId = response.data[0].columnId
                });
            },
            /*点击左边导航栏获取到level1ColumnId，然后把值传递给ArticleList*/
            getArticleByLevel1ColumnId(level1ColumnId){
                this.level1ColumnId = level1ColumnId
                // console.log("这里"+level1ColumnId)
            }
        }
    }
</script>

<style scoped>
    .left-nav-list:hover{
        background: #6495ED;
        /*color: white;*/
    }
    .left-nav-list-active{
        background: #6495ED;
        color: white;
    }
    .left-nav-container .left-nav-list{
        padding: 10px;
        cursor: pointer;
    }
    .left-nav-container{
        text-align: center;
        border: #6495ED 1px solid;
        box-shadow: 0 4px 6px rgba(0, 0, 0, .12), 0 0 8px rgba(0, 0, 0, .04);
        border-radius: 6px;
        width: 200px;
        margin: auto;
    }
    .article_list{
        /*margin-left: 30px;*/
    }
</style>
